<span *ngIf="!hasTooltip" [innerHTML]="fieldText ? fieldText: ''"></span>
<div class="field-cell" *ngIf="hasTooltip">
  <p [matTooltip]="tooltipText" matTooltipClass="tooltip_wide"
     [class.link-button]="fieldText === 'See more'" [innerHTML]="fieldText ? fieldText: ''"></p>
</div>
